import { jsxs, jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { UtilityButton } from "../utility-button/utility-button.es.js";
import { CalendarHeaderWrapper, CalendarHeaderControl, CalendarTitle } from "./calendar-header.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  first: PropTypes.bool,
  last: PropTypes.bool,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onSkipBack: PropTypes.func.isRequired,
  onSkipForward: PropTypes.func.isRequired
};
const CalendarHeader = ({
  children,
  first = false,
  last = false,
  onNext,
  onPrevious,
  onSkipBack,
  onSkipForward
}) => /* @__PURE__ */ jsxs(CalendarHeaderWrapper, { children: [
  /* @__PURE__ */ jsx(CalendarHeaderControl, { children: /* @__PURE__ */ jsx(
    UtilityButton,
    {
      disabled: first,
      icon: "double-left",
      magnitude: "small",
      onClick: onSkipBack,
      stopPropagation: true
    }
  ) }),
  /* @__PURE__ */ jsx(CalendarHeaderControl, { children: /* @__PURE__ */ jsx(
    UtilityButton,
    {
      disabled: first,
      icon: "left",
      magnitude: "small",
      onClick: onPrevious,
      stopPropagation: true
    }
  ) }),
  /* @__PURE__ */ jsx(CalendarTitle, { children }),
  /* @__PURE__ */ jsx(CalendarHeaderControl, { children: /* @__PURE__ */ jsx(
    UtilityButton,
    {
      disabled: last,
      icon: "right",
      magnitude: "small",
      onClick: onNext,
      stopPropagation: true
    }
  ) }),
  /* @__PURE__ */ jsx(CalendarHeaderControl, { children: /* @__PURE__ */ jsx(
    UtilityButton,
    {
      disabled: last,
      icon: "double-right",
      magnitude: "small",
      onClick: onSkipForward,
      stopPropagation: true
    }
  ) })
] });
CalendarHeader.propTypes = propTypes;
export {
  CalendarHeader
};
